var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsaRhodeIslandKeno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.407 36.864h65.71c7.177 0 13.051 5.911 13.051 13.136s-5.873 13.136-13.051 13.136h-65.71c-7.187 0-13.06-5.911-13.06-13.136s5.873-13.136 13.06-13.136z",
    fill: "#1260b6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.474 53.16c-1.618 5.407-6.625 9.376-12.499 9.376H15.313c-7.025-3.275-7.415-8.796-7.415-8.796h76.657l8.919-.581zM4.756 46.764c1.437-5.673 6.578-9.9 12.651-9.9h10.861c-8.996.619-15.335 1.552-16.687 2.732-2.703 2.351-4.474 7.139-4.474 7.139l-2.351.029z",
    fill: "#5e96cd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.616 38.587h62.616c6.235 0 11.347 5.14 11.347 11.413 0 6.283-5.102 11.423-11.347 11.423H18.616c-6.235 0-11.347-5.14-11.347-11.423 0-6.273 5.112-11.413 11.347-11.413z",
    fill: "#fedb68"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.328 53.084h93.353v1.009H3.328z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.318 52.722h93.353v1.019H3.318z",
    fill: "#db5884"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.328 50.247h93.353v1.019H3.328z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.328 50.552h93.353v1.019H3.328z",
    fill: "#db5884"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.328 47.516h93.353v1.019H3.328z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.328 48.172h93.353v1.019H3.328z",
    fill: "#db5884"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m17.397 40.548 1.19.495v5.283l5.283-5.778h7.71l-6.416 7.311 7.035 11.461h-7.52l-4.284-6.987-1.809 1.894v5.093H12.37zm30.347 0 11.29 7.663 3.037-2.418 5.188 13.527H60.29l-7.32-9.538v9.538h-5.226zm30.223-.114c5.892 0 10.528 4.093 10.528 9.7S83.717 60.29 77.824 60.29s-10.671-4.55-10.671-10.157 4.921-9.7 10.814-9.7zm-.495 4.15c2.189 0 3.96 2.18 3.96 5.435 0 3.246-1.771 5.883-3.96 5.883s-3.96-2.637-3.96-5.883c-.01-3.246 1.771-5.435 3.96-5.435z",
    fill: "#1f1f1f"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.749 54.093h5.216v-1.009h-5.75a5.94 5.94 0 0 0 .533 1.009z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.53 53.741h5.435v-1.019h-5.883a6.587 6.587 0 0 0 .447 1.019z",
    fill: "#db5884"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M75.73 51.257h6.787v-1.019h-6.873a8.64 8.64 0 0 0 .086 1.019z",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.778 51.561h6.74v-1.019h-6.863c.019.352.067.695.124 1.019z",
    fill: "#db5884"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M75.768 48.525h6.797v-1.019h-6.549a8.834 8.834 0 0 0-.247 1.019z",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M75.682 49.181h6.882v-1.019h-6.73l-.152 1.019z",
    fill: "#db5884"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.181 40.548h6.216v5.778l5.283-5.778h7.71l-6.416 7.311L31 59.319h-7.511l-4.284-6.987-1.809 1.894v5.093H11.18zm19.847 0h16.163v4.407h-9.938v2.551h8.167v4.369h-8.167v3.132h9.938v4.322H31.028V40.548zm17.287 0h6.073l7.139 9.567v-9.567H67.6V59.32h-6.073l-7.139-9.538v9.538h-6.073zm31.099-.562c5.892 0 10.671 4.541 10.671 10.147S85.306 60.29 79.414 60.29s-10.671-4.55-10.671-10.157 4.769-10.147 10.671-10.147zm.19 4.15c2.189 0 3.96 2.637 3.96 5.883s-1.771 5.883-3.96 5.883-3.96-2.637-3.96-5.883 1.771-5.883 3.96-5.883z",
    fill: "#1260b6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M65.107 41.985h-1.228v14.431L52.266 41.985h-1.694v16.22H51.8v-14.85l11.956 14.85h1.361v-16.22zm-31.632 0v16.22h11.832v-1.237H34.703v-6.254h9.243v-1.237h-9.243v-6.264h10.614v-1.237l-11.842.01zm-18.61 0h-1.228v16.22h1.228V53.96l4.95-5.15 6.225 9.395h1.466L20.69 47.896l5.683-5.911H24.67l-9.805 10.204zm64.787-.752c-4.683 0-8.472 3.922-8.472 8.758s3.789 8.758 8.472 8.758 8.472-3.922 8.472-8.758c.01-4.845-3.789-8.758-8.472-8.758zm0 1.323c-3.969 0-7.196 3.322-7.196 7.434 0 4.103 3.227 7.434 7.196 7.434s7.196-3.332 7.196-7.434c0-4.112-3.217-7.434-7.196-7.434z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsaRhodeIslandKeno);
export default __webpack_public_path__ + "static/media/usa_rhode_island_keno.4c0b1dc7019c5938f1a6147e7919bee6.svg";
export { ForwardRef as ReactComponent };